import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { LocalLanguage24Regular } from '@fluentui/react-icons';

import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ValidatedCollapseCard, FormCardBasicHeader } from '@bingads-webui-campaign-react/validated-form-cards';
import { FormCardBody } from '@bingads-webui-fluent-component/form-cards';

import { TargetingLanguage } from '../components/targeting-language';
import { LanguageSkeleton } from '../components/skeletons';

export const CollapsibleLanguage = ({ isLoading, isDisabled, ...cardProps }) => {
  const i18n = useContext(I18nContext);

  return (
    <ValidatedCollapseCard {...cardProps}>
      <FormCardBasicHeader
        title={i18n.getString(_TL_('Language'))}
        helpTopic="pop_BA_LinkedIn_Language"
        helpLabel={i18n.getString(_TL_('Click to learn more about language'))}
        contentBefore={<LocalLanguage24Regular />}
      />
      <FormCardBody>
        {!isLoading ? <TargetingLanguage isDisabled={isDisabled} /> : <LanguageSkeleton />}
      </FormCardBody>
    </ValidatedCollapseCard>
  );
};

CollapsibleLanguage.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool,
};

CollapsibleLanguage.defaultProps = {
  isDisabled: false,
};

